import React from 'react'
import {
    ElectionNoteText,
    RaceLine44,
    SampleMiniHorseShoeData,
} from '../components'
import { TopParty } from '../data'
import {
    TheRaceBarIndicatorContainer,
    TheRaceBarIndicator,
    TheRacePartyInnerRowContainer,
    TheRacePartyRowContainer,
    StyledRaceElectionText,
    TheRaceGraphWinIndicator,
    StyledRaceAmountText,
} from './TheRaceRow.styled'

export interface TheRaceRowProps {
    party: TopParty
    percentPerSeat: number
    winIndicator?: {
        show: boolean
        amountToWin: number
    }
}

export const TheRaceRow = ({
    party,
    percentPerSeat,
    winIndicator,
}: TheRaceRowProps) => {
    const color = party.color
    const predictedColor = party.predictedColor
    const toWinText = `${winIndicator?.amountToWin} to win`

    // Show the win indicator line (only optioned for the top party on the render)
    const IndicatorComponent =
        winIndicator && winIndicator.show === true ? (
            <TheRaceGraphWinIndicator
                percentFromRight={percentPerSeat * winIndicator?.amountToWin}
            >
                <ElectionNoteText>{toWinText}</ElectionNoteText>
                <RaceLine44 />
            </TheRaceGraphWinIndicator>
        ) : null

    const predictedPercent = percentPerSeat * party.seatsPredicted
    const percent = percentPerSeat * party.seats

    const BarComponent = (
        <TheRaceBarIndicatorContainer>
            {IndicatorComponent}
            <TheRaceBarIndicator
                widthPercent={predictedPercent}
                color={predictedColor}
            />
            <TheRaceBarIndicator widthPercent={percent} color={color} />
            <StyledRaceAmountText barPercent={predictedPercent}>
                {party.seatsPredicted}
            </StyledRaceAmountText>
        </TheRaceBarIndicatorContainer>
    )

    return (
        <TheRacePartyRowContainer key={party.code}>
            <TheRacePartyInnerRowContainer>
                <StyledRaceElectionText>{party.name}</StyledRaceElectionText>
                {BarComponent}
            </TheRacePartyInnerRowContainer>
            {/* <SampleMiniHorseShoeData /> TODO: Re-enable this when it's done */}
        </TheRacePartyRowContainer>
    )
}
